// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-primary);
  background: var(--color-black);
  color: var(--color-white);
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

.container {
  min-height: 100vh;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--spacing-md);
}

@media (min-width: 429px) {
  body {
    background: #1a1a1a;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  
  .container {
    background: var(--color-black);
  }
}

.button {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border-radius: 2rem;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  transition: transform 0.2s;
}

.button:active {
  transform: scale(0.95);
}

.button--primary {
  background: var(--color-red);
  color: var(--color-white);
}

.button--secondary {
  background: transparent;
  color: var(--color-white);
  border: 2px solid var(--color-white);
}

.hero {
  min-height: 40vh;
  display: flex;
  flex-direction: column;
}

.hero__nav {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: var(--spacing-sm) 0;
}

.hero__logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.1em;
}

.hero__logo-line {
  width: 2rem;
  height: 1px;
  background: var(--color-red);
  margin-bottom: 0.25rem;
}

.hero__logo-text {
  font-size: 0.5rem;
  margin-top: 0.125rem;
}

.hero__content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.hero__title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: var(--spacing-lg);
}

.hero__title-main {
  font-size: 4.5rem;
  font-weight: 900;
  line-height: 0.9;
  letter-spacing: -0.02em;
}

.hero__title-outline {
  font-size: 4.5rem;
  font-weight: 900;
  line-height: 0.9;
  -webkit-text-stroke: 2px var(--color-white);
  -webkit-text-fill-color: transparent;
}

.hero__title-sub {
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.15em;
  margin-top: 0.5rem;
  width: 100%;
  text-align: center;
}

.hero__image-wrapper {
  position: relative;
  width: 100%;
  max-width: 320px;
  margin: var(--spacing-lg) 0 6rem 0;
}

.hero__circle {
  position: absolute;
  top: -20%;
  left: -10%;
  width: 120%;
  height: auto;
  z-index: 1;
}

.hero__image {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 1rem;
  z-index: 2;
}

.welcome {
  padding: var(--spacing-xl) 0;
  text-align: center;
}

.welcome__title {
  font-size: 3rem;
  font-weight: 900;
  color: var(--color-red);
  line-height: 1;
  margin-bottom: var(--spacing-md);
}

.welcome__text {
  font-size: 0.9375rem;
  line-height: 1.6;
  max-width: 90%;
  margin: 0 auto;
}

.lineup {
  padding: var(--spacing-xl) 0;
}

.lineup__title {
  font-size: 3.5rem;
  font-weight: 900;
  color: var(--color-yellow);
  line-height: 0.9;
  margin-bottom: var(--spacing-lg);
}

.lineup__artists {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}

.artist-card {
  background: var(--color-white);
  color: var(--color-black);
  padding: var(--spacing-md);
  border-radius: 0.5rem;
}

.artist-card__name {
  font-size: 2rem;
  font-weight: 900;
  color: var(--color-red);
  margin-bottom: var(--spacing-sm);
}

.artist-card__image-wrapper {
  width: 100%;
  margin: var(--spacing-sm) 0;
}

.artist-card__image {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
}

.artist-card__description {
  font-size: 0.875rem;
  line-height: 1.5;
}

.recruitment {
  padding: var(--spacing-xl) 0;
  text-align: center;
}

.recruitment__image-wrapper {
  position: relative;
  width: 28vw;
  max-width: 100vw;
  margin-left: calc(-1 * var(--spacing-md));
  margin-right: calc(-1 * var(--spacing-md));
  margin-bottom: var(--spacing-md);
  background: #090909;
  padding-top: 4rem;
}


.recruitment__title {
  position: absolute;
  top: var(--spacing-md);
  left: 45%;
  transform: translateX(-50%);
  font-size: 3rem;
  font-weight: 500;
  color: var(--color-yellow);
  line-height: 1;
  z-index: 10;
  width: 100%;
  text-align: left;
  padding: 0 var(--spacing-md);
}

.recruitment__text {
  font-size: 0.9375rem;
  line-height: 1.6;
  margin-bottom: var(--spacing-lg);
}

.recruitment__image {
  width: 100%;
  height: auto;
  border-radius: 0;
  display: block;
}

.supporters {
  padding: var(--spacing-xl) 0;
}

.supporters__title {
  font-size: 3.5rem;
  font-weight: 900;
  color: var(--color-yellow);
  line-height: 0.9;
  margin-bottom: var(--spacing-md);
}

.supporters__text {
  font-size: 0.8125rem;
  line-height: 1.5;
  margin-bottom: var(--spacing-lg);
  color: var(--color-red);
}

.supporters__logos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-sm);
}

.supporters__logo {
  background: var(--color-white);
  color: var(--color-black);
  padding: var(--spacing-sm);
  border-radius: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-align: center;
}

.contact {
  padding: var(--spacing-xl) 0 var(--spacing-lg) 0;
}

.contact__title {
  font-size: 4rem;
  font-weight: 900;
  color: var(--color-red);
  line-height: 0.9;
  margin-bottom: var(--spacing-lg);
}

.contact__subtitle {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: var(--spacing-xs);
}

.contact__text {
  font-size: 0.875rem;
  margin-bottom: var(--spacing-sm);
}

.contact__email {
  font-size: 0.875rem;
  margin-bottom: var(--spacing-lg);
}

.contact__buttons {
  display: flex;
  gap: var(--spacing-xs);
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,0CAA0C;EAC1C,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":["@import './variables.css';\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-primary);\n  background: var(--color-black);\n  color: var(--color-white);\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n.container {\n  min-height: 100vh;\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: var(--spacing-md);\n}\n\n@media (min-width: 429px) {\n  body {\n    background: #1a1a1a;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n  }\n  \n  .container {\n    background: var(--color-black);\n  }\n}\n\n.button {\n  display: inline-block;\n  padding: 0.75rem 1.5rem;\n  border-radius: 2rem;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  transition: transform 0.2s;\n}\n\n.button:active {\n  transform: scale(0.95);\n}\n\n.button--primary {\n  background: var(--color-red);\n  color: var(--color-white);\n}\n\n.button--secondary {\n  background: transparent;\n  color: var(--color-white);\n  border: 2px solid var(--color-white);\n}\n\n.hero {\n  min-height: 40vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.hero__nav {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: var(--spacing-sm) 0;\n}\n\n.hero__logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 0.625rem;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n}\n\n.hero__logo-line {\n  width: 2rem;\n  height: 1px;\n  background: var(--color-red);\n  margin-bottom: 0.25rem;\n}\n\n.hero__logo-text {\n  font-size: 0.5rem;\n  margin-top: 0.125rem;\n}\n\n.hero__content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.hero__title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-bottom: var(--spacing-lg);\n}\n\n.hero__title-main {\n  font-size: 4.5rem;\n  font-weight: 900;\n  line-height: 0.9;\n  letter-spacing: -0.02em;\n}\n\n.hero__title-outline {\n  font-size: 4.5rem;\n  font-weight: 900;\n  line-height: 0.9;\n  -webkit-text-stroke: 2px var(--color-white);\n  -webkit-text-fill-color: transparent;\n}\n\n.hero__title-sub {\n  font-size: 1.25rem;\n  font-weight: 600;\n  letter-spacing: 0.15em;\n  margin-top: 0.5rem;\n  width: 100%;\n  text-align: center;\n}\n\n.hero__image-wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 320px;\n  margin: var(--spacing-lg) 0 6rem 0;\n}\n\n.hero__circle {\n  position: absolute;\n  top: -20%;\n  left: -10%;\n  width: 120%;\n  height: auto;\n  z-index: 1;\n}\n\n.hero__image {\n  position: relative;\n  width: 100%;\n  height: auto;\n  border-radius: 1rem;\n  z-index: 2;\n}\n\n.welcome {\n  padding: var(--spacing-xl) 0;\n  text-align: center;\n}\n\n.welcome__title {\n  font-size: 3rem;\n  font-weight: 900;\n  color: var(--color-red);\n  line-height: 1;\n  margin-bottom: var(--spacing-md);\n}\n\n.welcome__text {\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  max-width: 90%;\n  margin: 0 auto;\n}\n\n.lineup {\n  padding: var(--spacing-xl) 0;\n}\n\n.lineup__title {\n  font-size: 3.5rem;\n  font-weight: 900;\n  color: var(--color-yellow);\n  line-height: 0.9;\n  margin-bottom: var(--spacing-lg);\n}\n\n.lineup__artists {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xl);\n}\n\n.artist-card {\n  background: var(--color-white);\n  color: var(--color-black);\n  padding: var(--spacing-md);\n  border-radius: 0.5rem;\n}\n\n.artist-card__name {\n  font-size: 2rem;\n  font-weight: 900;\n  color: var(--color-red);\n  margin-bottom: var(--spacing-sm);\n}\n\n.artist-card__image-wrapper {\n  width: 100%;\n  margin: var(--spacing-sm) 0;\n}\n\n.artist-card__image {\n  width: 100%;\n  height: auto;\n  border-radius: 0.5rem;\n}\n\n.artist-card__description {\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.recruitment {\n  padding: var(--spacing-xl) 0;\n  text-align: center;\n}\n\n.recruitment__image-wrapper {\n  position: relative;\n  width: 28vw;\n  max-width: 100vw;\n  margin-left: calc(-1 * var(--spacing-md));\n  margin-right: calc(-1 * var(--spacing-md));\n  margin-bottom: var(--spacing-md);\n  background: #090909;\n  padding-top: 4rem;\n}\n\n\n.recruitment__title {\n  position: absolute;\n  top: var(--spacing-md);\n  left: 45%;\n  transform: translateX(-50%);\n  font-size: 3rem;\n  font-weight: 500;\n  color: var(--color-yellow);\n  line-height: 1;\n  z-index: 10;\n  width: 100%;\n  text-align: left;\n  padding: 0 var(--spacing-md);\n}\n\n.recruitment__text {\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  margin-bottom: var(--spacing-lg);\n}\n\n.recruitment__image {\n  width: 100%;\n  height: auto;\n  border-radius: 0;\n  display: block;\n}\n\n.supporters {\n  padding: var(--spacing-xl) 0;\n}\n\n.supporters__title {\n  font-size: 3.5rem;\n  font-weight: 900;\n  color: var(--color-yellow);\n  line-height: 0.9;\n  margin-bottom: var(--spacing-md);\n}\n\n.supporters__text {\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  margin-bottom: var(--spacing-lg);\n  color: var(--color-red);\n}\n\n.supporters__logos {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-sm);\n}\n\n.supporters__logo {\n  background: var(--color-white);\n  color: var(--color-black);\n  padding: var(--spacing-sm);\n  border-radius: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.contact {\n  padding: var(--spacing-xl) 0 var(--spacing-lg) 0;\n}\n\n.contact__title {\n  font-size: 4rem;\n  font-weight: 900;\n  color: var(--color-red);\n  line-height: 0.9;\n  margin-bottom: var(--spacing-lg);\n}\n\n.contact__subtitle {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin-bottom: var(--spacing-xs);\n}\n\n.contact__text {\n  font-size: 0.875rem;\n  margin-bottom: var(--spacing-sm);\n}\n\n.contact__email {\n  font-size: 0.875rem;\n  margin-bottom: var(--spacing-lg);\n}\n\n.contact__buttons {\n  display: flex;\n  gap: var(--spacing-xs);\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
